import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserType } from '../../../../../../shared/schemas/userSchema';
import { SnackBarService } from '../../../services/snack-bar.service';
import {
  addUserToStore,
  deleteUserStore,
} from '../../../store/slices/usersSlice/usersSlice.actions';
import { selectAllUsers } from '../../../store/slices/usersSlice/usersSlice.selector';
import { UsersService } from '../services/users.service';
import { AppStore } from './../../../store/store';

@Component({
  selector: 'app-all-users',
  templateUrl: './all-users.component.html',
  styleUrl: './all-users.component.scss',
})
export class AllUsersComponent implements OnInit, OnDestroy {
  loading = false;
  users$: Observable<UserType[]> = this.store.pipe(select(selectAllUsers));

  private destroy$ = new Subject<void>();

  constructor(
    private store: Store<AppStore>,
    private userService: UsersService,
    private snackBar: SnackBarService,
  ) {}

  ngOnInit(): void {
    // Always fetch on mount — the "if (users.length === 0) fetch" guard
    // was broken because session-restore pre-populates the store with the
    // logged-in admin, so the fetch was never triggered.
    this.fetchUsers();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private fetchUsers(): void {
    this.loading = true;
    this.userService
      .getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (fetched) => {
          fetched.forEach((user) => this.store.dispatch(addUserToStore({ user })));
          this.loading = false;
        },
        error: () => (this.loading = false),
      });
  }

  async onSubmit(userId: string): Promise<void> {
    this.loading = true;
    try {
      const obs = await this.userService.deleteUser(userId);
      obs.subscribe({
        next: () => {
          this.store.dispatch(deleteUserStore({ userId }));
          this.snackBar.openSnackBar('נמחק בהצלחה', 'x');
        },
        error: (err) => {
          console.error('Delete failed:', err);
          this.snackBar.openSnackBarError('לא ניתן למחוק', 'x');
        },
      });
    } catch (error) {
      console.error(error);
      this.snackBar.openSnackBarError('לא ניתן למחוק', 'x');
    } finally {
      this.loading = false;
    }
  }
}
